import { AxiosError } from 'axios';

import { apiService } from '../../../shared/services/apiServices';
import {
  EQUIPMENT_ERROR_MESSAGES,
  FACILITY_VIEW_ERROR_MESSAGES,
} from '../errors';
import type { MediaResource } from '../types/addEquipmentType';
import equipmentEndpoints from './equipmentEndpoints';

export interface EditEquipmentPayload {
  name?: string | undefined;
  description?: string | undefined;
  category?: string | undefined;
  serialNumber?: string | undefined;
  modelName?: string | undefined;
  dateOfProduction?: string | undefined;
  image?: MediaResource | undefined;
  docs?: MediaResource[] | undefined;
}

export interface EditEquipmentResult {
  success: boolean;
  error?: string;
  fieldErrors?: { serialNumber?: string };
}

export const editEquipment = async (
  id: string,
  payload: EditEquipmentPayload
): Promise<EditEquipmentResult> => {
  try {
    const result = await apiService.patchAPI(
      equipmentEndpoints.EDIT_EQUIPMENT(id),
      payload,
      { skipGlobalErrorRedirect: true }
    );

    if (result.error) {
      if (result.status === 403) {
        return {
          success: false,
          error: FACILITY_VIEW_ERROR_MESSAGES.NO_PERMISSION_TOOLTIP,
        };
      }
      if (result.status === 409) {
        return {
          success: false,
          fieldErrors: {
            serialNumber: EQUIPMENT_ERROR_MESSAGES.SERIAL_NUMBER_DUPLICATE,
          },
        };
      }
      return {
        success: false,
        error: result.isNetworkError
          ? EQUIPMENT_ERROR_MESSAGES.NETWORK_ERROR
          : EQUIPMENT_ERROR_MESSAGES.DEFAULT_ERROR,
      };
    }

    return { success: true };
  } catch (err) {
    if (err instanceof AxiosError) {
      const isNetworkError = !err.response && !!err.request;
      return {
        success: false,
        error: isNetworkError
          ? EQUIPMENT_ERROR_MESSAGES.NETWORK_ERROR
          : EQUIPMENT_ERROR_MESSAGES.UNEXPECTED_ERROR,
      };
    }
    return { success: false, error: EQUIPMENT_ERROR_MESSAGES.UNEXPECTED_ERROR };
  }
};
